import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmpresaAdministrador } from '../../constants';

const { Representacao } = EmpresaAdministrador;

export default function SelectEmpresaAdministradorRepresentacao(props) {
  const { t } = useTranslation();

  const createOption = ({ id, label }) => (
    <Select.Option value={id}>
      {t(label)}
    </Select.Option>);

  return (
    <Select {...props} >
      {createOption(Representacao.Isolada)}
      {createOption(Representacao.Conjunta)}
      {createOption(Representacao.Mista)}
    </Select>
  );
}

SelectEmpresaAdministradorRepresentacao.propTypes = {
  value: PropTypes.oneOf([
    Representacao.Isolada.id,
    Representacao.Conjunta.id,
    Representacao.Mista.id,
  ]),
  onChange: PropTypes.func,
};
